import { Translation } from "../model/Language.js";

export interface ModalItemOptions {
    label: Translation;
    subtitle?: Translation;
    icon: string;
    url?: string;
    action?: string;
    iconSize?: "normal" | "large" | "extralarge";
    closeOnClick?: boolean;
}

export class ModalItem {

    public readonly element: HTMLLIElement;

    private _icon: string;
    private _iconSize: "normal" | "large" | "extralarge";
    private _label: Translation;

    constructor(options: ModalItemOptions) {
        var element = document.createElement("li");
        this.element = element;

        options = e5.object.merge({
            closeOnClick: true,
            iconSize: "normal"
        } as ModalItemOptions, options);

        this._icon = options.icon;
        this._iconSize = options.iconSize;
        this._label = options.label;

        element.className = "awi-navigation__list-item";

        if (options.closeOnClick) {
            element.classList.add("awi-modal__close");
        }

        if (options.url) {
            var link = document.createElement("a");
            link.className = "awi-navigation__list-item-link";
            link.target = "_blank";
            link.href = options.url;
            element.appendChild(link);
        } else {
            var btn = document.createElement("button");
            btn.className = "awi-navigation__list-item-link";
            btn.type = "button";
            element.appendChild(btn);
        }

        var itemLink = element.querySelector(".awi-navigation__list-item-link");

        if (options.action) {
            itemLink.setAttribute("data-action", options.action);
        }

        var itemHeader = document.createElement("div");
        itemHeader.className = "awi-navigation__list-item-header";
        itemLink.appendChild(itemHeader);

        if (options.subtitle) {
            var itemFooter = document.createElement("div");
            itemFooter.className = "awi-navigation__list-item-footer";
            itemLink.appendChild(itemFooter);

            var subtitle = document.createElement("span");
            subtitle.className = "awi-navigation__list-item-subtitle";
            lang.set(subtitle, options.subtitle);
            itemFooter.appendChild(subtitle);
        }

        var label = document.createElement("span");
        label.className = "awi-navigation__list-item-label";
        lang.set(label, options.label);
        itemHeader.appendChild(label);

        var state = document.createElement("span");
        state.className = "awi-navigation__list-item-state";
        itemHeader.appendChild(state);

        var iconString = options.icon;
        iconString += " awi-navigation__list-item-icon--size-" + this._iconSize;

        var icon = document.createElement("span");
        icon.className = "awi-navigation__list-item-icon " + iconString;
        icon.setAttribute("aria-hidden", "true");
        itemHeader.appendChild(icon);

        // <li class="awi-navigation__list-item <?php echo $item['current'] ? 'awi-navigation__list-item--current' : ''; ?>">
        //         <a class="awi-navigation__list-item-link" <?php echo $url ?> target="_self">
        //             <div class="awi-navigation__list-item-header">
        //                 <?php echo $indentation; ?>
        //                 <span class="awi-navigation__list-item-label" <?php echo $label ?>></span>
        //                 <?php if ($item['current']) : ?>
        //                     <span class="awi-navigation__list-item-state fal fa-check" aria-hidden="true"></span>
        //                 <?php else : ?>
        //                     <span class="awi-navigation__list-item-state" aria-hidden="true"></span>
        //                 <?php endif; ?>
        //                 <span class="awi-navigation__list-item-icon <?php echo $item['icon']; ?>" aria-hidden="true"></span>
        //             </div>
        //             <?php if ($subtitle) : ?>
        //                 <div class="awi-navigation__list-item-footer">
        //                     <?php echo $indentation; ?>
        //                     <div class="awi-navigation__list-item-subtitle" <?php echo $subtitle; ?>></div>
        //                 </div>
        //             <?php endif; ?>
        //         </a>
        //     </li>
    }

    public get url(): string {
        return this.element.querySelector<HTMLAnchorElement>(".awi-navigation__list-item-link").href;
    }

    public set url(value: string) {
        this.element.querySelector<HTMLAnchorElement>(".awi-navigation__list-item-link").href = value;
    }

    public get icon(): string {
        return this._icon;
    }

    public set icon(value: string) {
        if (this._icon === value) {
            return;
        }
        this._icon = value;

        var iconString = value;
        iconString += " awi-navigation__list-item-icon--size-" + this._iconSize;

        var icon = this.element.querySelector(".awi-navigation__list-item-icon");
        icon.className = "awi-navigation__list-item-icon " + iconString;
    }

    public set iconInactive(value: boolean) {
        var icon = this.element.querySelector(".awi-navigation__list-item-icon");
        icon.classList.toggle("awi-navigation__list-item-icon--inactive", value);
    }

    public get iconInactive(): boolean {
        var icon = this.element.querySelector(".awi-navigation__list-item-icon");
        return icon.classList.contains("awi-navigation__list-item-icon--inactive");
    }

    public get label(): Translation {
        return this._label;
    }

    public set label(value: Translation) {
        this._label = value;
        lang.set(this.element.querySelector(".awi-navigation__list-item-label"), this._label);
    }
}